// const baseUrl = "https://auraskinpremium.com"; // your live domain
// const defaultImage = `${baseUrl}/images/og-default.jpg`;

const seoConfig = {
  default: {
    siteName: "Aura Skin Premium",
    title: "Aura Skin Premium",
    description:
      "Premium Korean skincare soaps – Deep Cleansing, Oxygen Bar & Chok Chok Glow. Elevate your aura with trusted beauty.",
    // image: defaultImage,
    type: "website",
  },

  pages: {
    home: {
      title: "Home",
      description:
        "Discover Aura Skin Premium – Elevate your aura with Korean luxury skincare.",
      // image: `${baseUrl}/images/home-banner.jpg`,
    },

    productDetails: {
      title: "Product Details",
      description:
        "Explore product details, benefits, and usage of Aura Skin Premium’s Korean skincare collection.",
      // image: `${baseUrl}/images/product-detail-banner.jpg`,
      type: "product",
    },

    blogDetails: {
      title: "Blog Details",
      description:
        "Read detailed articles and guides from Aura Skin Premium’s skincare experts.",
      // image: `${baseUrl}/images/blog-detail-banner.jpg`,
      type: "article",
    },

    affiliateProgram: {
      title: "Affiliate Program",
      description:
        "Join Aura Skin Premium’s affiliate program and earn by promoting luxury Korean skincare.",
      // image: `${baseUrl}/images/affiliate-banner.jpg`,
    },

    contact: {
      title: "Contact Us",
      description:
        "Get in touch with Aura Skin Premium for support, queries, and business inquiries.",
      // image: `${baseUrl}/images/contact-banner.jpg`,
    },

    refundPolicy: {
      title: "Refund Policy",
      description:
        "Learn about Aura Skin Premium’s refund policy. Easy returns and customer-first guarantee.",
      // image: `${baseUrl}/images/refund-policy-banner.jpg`,
      type: "article",
    },

    shippingPolicy: {
      title: "Shipping Policy",
      description:
        "Review Aura Skin Premium’s shipping policy including delivery times and charges.",
      // image: `${baseUrl}/images/shipping-policy-banner.jpg`,
      type: "article",
    },

    returnsAndExchangePolicy: {
      title: "Returns & Exchange Policy",
      description:
        "Understand Aura Skin Premium’s returns and exchange policy for a smooth shopping experience.",
      // image: `${baseUrl}/images/returns-policy-banner.jpg`,
      type: "article",
    },
  },
};

export default seoConfig;
